// extracted by mini-css-extract-plugin
export default {"section2":"EnergyConsumptionFuelingPage_section2__4hc4X","footer":"EnergyConsumptionFuelingPage_footer__qavEf"};